import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import * as moment from 'moment';

import { AuthenticationService } from '../services/auth.service';
import { NotificationService } from '../services/notification.service';
import { Role } from '@app/services/Roles/roleEnum';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private notificationService: NotificationService,
    private authService: AuthenticationService
  ) {}

  async canActivate() {
    const user = this.authService.getCurrentUser();
    const clinic = this.authService.getCurrentClinic();
    const isOnlyPharmacyOperator =
      user?.roles.length === 2 && user?.roles.includes(Role.PharmacyOperator);
    let errorMessage: string | null = null;

    if (user && user.expiration) {
      if (moment() < moment(user.expiration)) {
        if (isOnlyPharmacyOperator) return true;
        if (clinic) return true;
        else {
          errorMessage = 'No clinic found';
        }
      } else {
        errorMessage = 'Your session has expired';
      }
    }

    if (errorMessage) this.notificationService.openSnackBar(errorMessage);
    await this.router.navigate(['auth/login']);
    return false;
  }
}
